export default __webpack_public_path__ + "static/affiliate-program-Software-1@mob-ac05bad937cea1a312132076b885ca32.png";